export default "__VITE_ASSET__859506a2__"